import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, makeApiReducer, ApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import { CreateReassessmentResponse } from '../models';


const KEY_ACTION = ActionType.ReassessmentRequest;
const ACTIONS    = [
  ActionType.ReassessmentRequest,
  ActionType.ReassessmentResponse,
  ActionType.ReassessmentError,
];


type Payload = CreateReassessmentResponse;


type Meta = {
  displayProjectId: string;
};


/**
 * Dispatch this action to create a reassessment rater for the current project and participant
 *
 * @param displayProjectId  - the display Id of the project whose reassessment rater we want
 * @param participantId - the database Id of the participant whose reassessment rater we want
*/
export const reassessmentAction = (
  displayProjectId: string,
  participantId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.CreateReassessmentRater,
    headers:  { 'content-type': 'application/json', 'accept': 'application/json' },
    body:     JSON.stringify({
      displayProjectId,
      participantId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { displayProjectId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${displayProjectId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { displayProjectId } = action.meta;
  const metaTag       = `${displayProjectId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  if (!payload) {
    return successState;
  }

  return R.assoc('reassessmentSurveyUrl', payload.participants[0].surveyUrl, successState);
};

export const reassessmentReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
